import { useCallback, useEffect } from 'react'

import { ReportSection, ResetLink } from 'app/common/templates-next/report-template'
import ReportFilterForm from 'app/common/templates-next/report-template/report-filter-form'
import ReportFilterLayout from 'app/common/templates-next/report-template/report-filter-layout'
import { DetailsBox, detailsBoxID } from 'app/common/ui-next/_filter-compilations/details'

// import { useUser } from 'app/dataProviders/user/hooks'
import { useReportPerform } from 'app/dataProviders/reports/hooks'
import { ReportType } from 'app/dataTypes/reports'
import { canMailingOnly, MailingBox } from 'app/common/ui-next/_filter-compilations/mailing'

import {
  DayCaresListFilter,
  ClassTypeFilter,
  MonthFilter,
  OrgsFilter,
  OrgTypesFilter,
  SchoolYearFilter,
  ClassesListFilter,
  StudentListFilter,
  AllowancesFilter
} from './filterItems'

import { filterInit, resetToDefaultAll } from './filter-init'
import { GroupedSubsidyFilterKey as FilterKey } from './filterItems/types'
import styles from './Filters.scss'
import { monthFilterSelection, orgsFilterSelection, schoolYearFilterSelection } from 'app/dataProviders/filter-items'
import { useDataBoxSelector } from 'app/common/data-box-store'
const isMailingOnly = (formData: FormData) => !!canMailingOnly(formData)

type Props = {
  onReportId: (reportID: string | null) => void
}
export const Filters = ({ onReportId }: Props) => {
  // const { email, loading } = useUser()
  const orgId = useDataBoxSelector(orgsFilterSelection, () => orgsFilterSelection.data)
  const schoolyear = useDataBoxSelector(schoolYearFilterSelection, () => schoolYearFilterSelection.data)
  const month = useDataBoxSelector(monthFilterSelection, () => monthFilterSelection.data)
  const disabledSubmitBtn = !orgId.length || !schoolyear.length || !month.length

  const { perform } = useReportPerform({
    onReportId,
    isMailingOnly,
  })

  const resetAll = () => {
    resetToDefaultAll()
  }

  const performWithAdditionalData = useCallback(
    async (formData: FormData) => {
      await perform({ formData, reportType: ReportType.SubsidiesGrouped })
    },
    [perform],
  )

  useEffect(() => {
    return filterInit()
  }, [])

  return (
    <ReportSection
      header="Фильтры"
      headerBar={<ResetLink onClick={resetAll}>{'Сбросить все фильтры'}</ResetLink>}
      resetStickyShift={false}
      skipPadding
    >
      <div className={styles.formContent}>
        <ReportFilterForm
          onSubmit={performWithAdditionalData}
          disabled={disabledSubmitBtn}
          submitButtonTitle="Сформировать"
        >
          {(pending) => (
            <ReportFilterLayout
              column1={
                <>
                  <OrgTypesFilter id={FilterKey.OrgTypes} pending={pending} />
                  <OrgsFilter id={FilterKey.Org} pending={pending} />
                  <SchoolYearFilter id={FilterKey.SchoolYear} pending={pending} />
                  <AllowancesFilter id={FilterKey.Allowances} pending={pending} />
                </>
              }
              column2={
                <>
                  <MonthFilter id={FilterKey.Month} pending={pending} />
                  <ClassTypeFilter id={FilterKey.ClassType} pending={pending} />
                  <DayCaresListFilter id={FilterKey.DayCaresList} pending={pending} />
                  <ClassesListFilter id={FilterKey.ClassesList} pending={pending} />
                  <StudentListFilter id={FilterKey.StudentList} pending={pending} />
                  {/* <MailingBox visibleFromBox={detailsBoxID} disabled={pending} />  */}
                </>
              }
            />
          )}
        </ReportFilterForm>
      </div>
    </ReportSection>
  )
}
